<ion-content>

  <ion-fab vertical="top" horizontal="end" slot="fixed" (click)="closeModalBeneficiaryDetail()">
    <ion-fab-button size="small">
        <ion-icon name="close"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <ion-grid>

    <!-- Icono del usuario -->
    <ion-row class="ion-justify-content-center">

      <!-- Header -->
      <ion-col size="12" class="ion-text-center">
        <h3 class="secondary-text" *ngIf="newBeneficiary">Crear Beneficiario</h3>
        <h3 class="secondary-text"*ngIf="!newBeneficiary">Editar Beneficiario</h3>
      </ion-col>

      <!-- Formulario -->
      <ion-col size="12" size-md="8" class="ion-no-padding">
        <!-- nombres -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Nombres</ion-label>
          <ion-input [(ngModel)]="userData.name" name="name" inputmode="text" type="text" placeholder="Digita aquí..." required></ion-input>
        </ion-item>

        <!-- apellidos -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Apellidos</ion-label>
          <ion-input [(ngModel)]="userData.surname" name="surname" inputmode="text" type="text" placeholder="Digita aquí..." required></ion-input>
        </ion-item>

        <!-- genero -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Genero</ion-label>        
          <ion-select [(ngModel)]="userData.gender" class="secondary-text" cancelText="Cancelar" required>
            <ion-select-option value="H">Hombre</ion-select-option>
            <ion-select-option value="M">Mujer</ion-select-option>
          </ion-select>
        </ion-item>

        <!-- tipo documento -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Tipo documento</ion-label>
          <ion-select [(ngModel)]="userData.documentType" class="secondary-text" okText="Ok" cancelText="Cerrar">
            <ion-select-option value="1">cc ciudadanía</ion-select-option>
            <ion-select-option value="1">tarjeta identidad</ion-select-option>
            <ion-select-option value="4">cc extranjería</ion-select-option>
            <ion-select-option value="5">Pasaporte</ion-select-option>
            <ion-select-option value="6">Nit</ion-select-option>
          </ion-select>
        </ion-item>

        <!-- documento -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Documento</ion-label>
          <ion-input [(ngModel)]="userData.document" name="document" inputmode="numeric" type="number" placeholder="Digita aquí..." required></ion-input>
        </ion-item>

        <!-- parentesco -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Parentesco</ion-label>        
          <ion-select [(ngModel)]="userData.role" class="secondary-text" cancelText="Cancelar" required>
            <ion-select-option value="titular">Titular</ion-select-option>
            <ion-select-option value="relacion">En relación</ion-select-option>
            <ion-select-option value="hijo">Hijo (a)</ion-select-option>
            <ion-select-option value="madre">Madre</ion-select-option>
            <ion-select-option value="padre">Padre</ion-select-option>
            <ion-select-option value="abuelo">Abuelo (a)</ion-select-option>
            <ion-select-option value="hermano">Hermano (a)</ion-select-option>
            <ion-select-option value="primo">Primo (a)</ion-select-option>
            <ion-select-option value="tio">Tío (a)</ion-select-option>
            <ion-select-option value="amigo">Amigo (a)</ion-select-option>
            <ion-select-option value="otro">Otro</ion-select-option>
          </ion-select>
        </ion-item>

        <!-- ciudad -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Ciudad</ion-label>        
          <ion-select [(ngModel)]="userData.city" class="secondary-text" cancelText="Cancelar" required>
            <ion-select-option *ngFor="let city of cities" [value]="city.code">{{ city.name }}</ion-select-option>
          </ion-select>
        </ion-item>

        <!-- fecha de nacimiento -->
        <ion-item class="form-input">
          <ion-label position="stacked" color="secondary">Fecha de nacimiento</ion-label>        
          <input matInput [(ngModel)]="userData.birthday" [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
            placeholder='Clic en el calendario' readonly required class="date-input">
          <mat-datepicker-toggle matSuffix [for]="picker" slot="end"></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>
        </ion-item>

        <!-- celular -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">Celular</ion-label>
          <ion-input [(ngModel)]="userData.mobile" name="mobile" inputmode="numeric" type="number" placeholder="Digita aquí..." required></ion-input>
        </ion-item>

        <!-- eps -->
        <ion-item class="form-input">
          <ion-label position="floating" color="secondary">EPS (opcional)</ion-label>
          <ion-input [(ngModel)]="userData.eps" name="eps" inputmode="text" type="text" placeholder="Digita aquí..."></ion-input>
        </ion-item>

      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <!-- Botones -->
    <div class="ion-text-center">
      <ion-button *ngIf="!savingData" (click)="validateAction()" class="button-beneficiary">Guardar</ion-button>
      <ion-button *ngIf="savingData" class="button-beneficiary" fill="outline">Guardando <ion-spinner name="dots"></ion-spinner></ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
